/* ***** ----------------------------------------------- ***** **
** ***** Infinite Scroll JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power2 */
(function($){
	'use strict';

	Main.modules.infiniteScroll = function() {

		var $body = $('body'),
			$content = $('.l-content'),
			$loadMore = $('.js-load_more', '.l-content'),
			$pagination = $('.o-pagination'),
			errorMessage = '<h2 style="padding:3rem">There was an error with your request. Please try again.</h2>',
			loadedText = '// All Items Have Been Loaded',
			loadingText = '// Loading...',
			modules = Main.modules,
			pageTitle = document.title,
			staggerDuration = 0.8,
			staggerLength = 50,
			staggerOpacity = 0,
			staggerOffset = 0.1,
			$container,
			newElements,
			newestMonthInEvents,
			nextPageURL,
			loadMoreText,
			oldestMonthInEvents,

			infiniteScrollNews = function() {
				infiniteScroll('.l-news_articles');
			},

			infiniteScrollMedia = function() {
				infiniteScroll('.l-media_articles');
			},

			infiniteScrollArchive = function() {
				infiniteScroll('.l-archive_articles');
			},

			infiniteScrollEvents = function() {
				infiniteScroll('.c-events');
			},

			infiniteScroll = function(container) {

				$loadMore.on('click', function(e) {
					e.preventDefault();

					var $this = $(this),
						url = $this.attr('href');

					loadMoreText = $(this).text();

					// Load new items from URL provided
					// Look for the items in the specified article container
					loadNewItems(url, container);

					// Change text link to loading and display loading animation
					$pagination.addClass('o-pagination--infinite_scroll--is_loading');
					$this.text(loadingText);

				});

			},

			loadNewItems = function(url, container) {

				$.ajax({
					url: url,
					success: function(html) {

						$container = $(container);

						// Change link text to original copy and hide loading animation
						$loadMore.text(loadMoreText);
						$pagination.removeClass('o-pagination--infinite_scroll--is_loading');
						
						// Parse the content of the new page
						newElements = $(container + ' .o-load_item', html);

						// Check if load more button exists on the loaded page
						// If so, set URL of load more button to the URL found on the loaded page's button
						// If so, we are at the end of the list so display loaded text and disable
						nextPageURL = $('.js-load_more', html).attr('href');
						if (nextPageURL != null) {
							$loadMore.attr('href', nextPageURL);
						} else {
							$loadMore.text(loadedText);
							$loadMore.addClass('o-text_link--disabled');
						}

						// Update URL to reflect the newly loaded posts
						pageTitle = $(html).filter('title').text();
						History.replaceState({infiniteScroll: 1}, pageTitle, url);

						// Add new items to current page
						$container.append(newElements);

						// Have newly loaded items fade in from the bottom
						TweenMax.staggerFrom(newElements, staggerDuration, {
							opacity: staggerOpacity,
							y: staggerLength,
							ease: Power2.easeOut
						}, staggerOffset);

						// Initialize lazy load for the newly loaded items
						modules.lazyLoad().lazyLoad();

						// For Events pagination, if the oldest month in the current list is the
						// same as the latest month in the newly loaded items, remove
						// This is to prevent duplicate month labels
						if (container == '.c-events') {
							newestMonthInEvents = $(newElements[0]).find('.c-events-group_title').text();
							if (oldestMonthInEvents == newestMonthInEvents) {
								$(newElements[0]).remove();
							}
							oldestMonthInEvents = $container.find('.c-events-group_header:last').find('.c-events-group_title').text();
						}

					},
					error: function() {
						$content.html(errorMessage);
					}

				});

			};

		return {
			init: function() {
				if ($body.hasClass('category-news')) {

					infiniteScrollNews();

				} else if ($body.hasClass('category-videos')
					|| $body.hasClass('category-music')) {

					infiniteScrollMedia();

				} else if ($body.hasClass('category')
					|| $body.hasClass('search')
					|| $body.hasClass('author')) {

					infiniteScrollArchive();

				} else if ($body.hasClass('post-type-archive-event')) {

					infiniteScrollEvents();

				}
			},
			infiniteScrollNews: infiniteScrollNews,
			infiniteScrollMedia: infiniteScrollMedia,
			infiniteScrollArchive: infiniteScrollArchive,
			infiniteScrollEvents: infiniteScrollEvents
		}
		
	};

})(jQuery);